import {remote} from '../constants/environment';
import {IBalanceSheetItem, IClient} from '../interfaces/dtos';
import {defaultHeaders} from './headers';
import {IBalanceSheetResponse} from '../interfaces/services';

import {customFetch as fetch, remoteCall} from '../utils/services';

export const getSubclientBalanceSheet = async (
  client: IClient,
  token: string,
): Promise<IBalanceSheetResponse> => {
  const remoteURI = remote.getSubclientBalanceSheetUri(client.id);

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();
        if (data.success && data.payload) {
          const success = true;
          const {balance} = data.payload;

          return {
            success,
            payload: balance as IBalanceSheetItem[],
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IBalanceSheetResponse;
};
